import React from 'react';
import { Link } from 'react-router-dom';
import { TbArrowRight } from 'react-icons/tb';

// Cartão de um guia (home e página /guias). Estilos em pages/Home.css (.nvh-guide).
const GuideCard = ({ guia }) => {
  const Icon = guia.icon;
  return (
    <Link to={`/guias/${guia.slug}`} className="nvh-guide">
      <Icon className="nvh-guide-icon" aria-hidden="true" />
      <h3>{guia.cardTitle}</h3>
      <p>{guia.cardText}</p>
      <span className="nvh-link">
        Ler o guia <TbArrowRight aria-hidden="true" />
      </span>
    </Link>
  );
};

export default GuideCard;
